import { PeriodValue } from "features/common/Interfaces";
import { API, IResponse } from "./API";

interface ITeacherProgress {
  _teacherId: number;
  _teacherName: string;
  _assignedLos: number;
  _completedLos: number;
}

export interface IProgressTeachersResponse extends IResponse {
  _entity: {
    _teacherProgressList: ITeacherProgress[];
    _generationTime: string;
  };
}

export interface IProgressTeacherRequest {
  period: PeriodValue;
  teacher: string;
}

interface IClassProgress {
  _classId: number;
  _className: string;
  _gradeId?: number;
  _gradeCode?: string;
  _teacherId?: number;
  _teacherName?: string;
  _assignedLos: number;
  _completedLos: number;
}

export interface IProgressTeacherResponse extends IResponse {
  _entity: {
    _teacherId: number;
    _teacherName: string;
    _classProgressList: IClassProgress[];
    _generationTime: string;
  };
}

interface IGradeProgress {
  _gradeId: number;
  _gradeCode: string;
  _assignedLos: number;
  _completedLos: number;
}

export interface IProgressGradesResponse extends IResponse {
  _entity: {
    _gradeProgressList: IGradeProgress[];
    _generationTime: string;
  };
}

export interface IProgressGradeResponse extends IResponse {
  _entity: {
    _gradeId: number;
    _gradeCode: string;
    _classProgressList: IClassProgress[];
    _generationTime: string;
  };
}
export interface IProgressGradeRequest {
  period: PeriodValue;
  grade: string;
}
interface IStudentProgress {
  _studentId: number;
  _studentName: string;
  _assignedLos: number;
  _completedLos: number;
}
export interface IProgressClassResponse extends IResponse {
  _entity: {
    _teacherId: number;
    _teacherName: string;
    _classId: number;
    _className: string;
    _gradeId: number;
    _gradeCode: string;
    _studentProgressList: IStudentProgress[];
  };
}

interface IProgressClassRequest {
  period: PeriodValue;
  classId: string;
}

export interface IMonthEntity {
  _month: string;
  _lessonsAssigned: number;
  _lessonsCompleted: number;
  _freePlayAssigned: number;
  _freePlayCompleted: number;
}

interface ITeacherAssignmentEntity {
  _teacherName: string;
  _lessonsAssigned: number;
  _lessonsCompleted: number;
  _freePlayAssigned: number;
  _freePlayCompleted: number;
}

interface ILessonsNFreePlayResponse extends IResponse {
  _entity: {
    _studentCount: number;
    _studentLoginPercentage: number;
    _months: IMonthEntity[];
    _teachersAssignment: ITeacherAssignmentEntity[];
    _reportGenerationTime: string;
  };
}
export interface IGradeTotalQuestions {
  _gradeName: string;
  _lessonsCompleted: number;
  _lessonsQuestions: number;
  _freePlayQuestions: number;
}
export interface ITeacherTotalQuestions {
  _teacherName: string;
  _grades: IGradeTotalQuestions[];
}
interface ITotalQuestionsResponse extends IResponse {
  _entity: {
    _grades: IGradeTotalQuestions[];
    _teachersAssignment: ITeacherTotalQuestions[];
    _reportGenerationTime: string;
  };
}

export interface IReadBookEntity {
  _monthName: string;
  _numberOfStudents: number;
  _numberOfBooks: number;
}
export interface ITop8AchieverEntity {
  _studentName: string;
  _completedGRBooks: number;
  _timeSpent: number;
  _monthName: string;
}
interface IGRStatisticsResponse extends IResponse {
  _entity: {
    _activeStudentPercentage: number;
    _averageTimeSpent: number;
    _averageCompletedBooks: number;
    _monthlyBookReads: IReadBookEntity[];
    _top8Achievers: ITop8AchieverEntity[];
    _reportGenerationTime: string;
  };
}
export interface IDomainFormativeDataEntity {
  _averageDomainScore: number;
  _domainLanguageCode: string;
  _totalCompletedLosForDomain: number;
  _totalSubmittedOfflineAssessmentsForDomain: number;
  _totalEvaluatedOfflineAssessmentsForDomain: number;
  _totalAssignedLosForDomain: number;
}

export interface IDomainFormativeData {
  domainLanguageTitle: string;
  domainLanguageCode: string;
  totalAssignedStudents: number;
  submittedAssessments: number;
  avgCompletedStudents: number;
  evaluatedAssessments: number;
  avgScore: number;
}

export interface IDataEntity {
  _totalAssignedLos: number;
  _totalCompletedLos: number;
  _avgScore: number;
}

export interface IFormativeEntity {
  totalAssigned: number;
  totalCompleted: number;
  avgScore: number;
}
export interface ITeacherDataEntity extends IDataEntity {
  _teacherId: string;
  _teacherName: string;
}

export interface ITeachersDataEntity extends IDomainFormativeDataEntity {
  _teachers: ITeacherDataEntity[];
}
export interface IFormativeTeachersResponse extends IResponse {
  _entity: {
    _generationTime: string;
    _domainResponse: ITeachersDataEntity[];
  };
}

export interface ITeacherFormativeData extends IFormativeEntity {
  teacherCode: string;
  teacherFirstName: string;
  teacherLastName: string;
}
export interface ITeachersDomainFormativeData extends IDomainFormativeData {
  teachers: ITeacherFormativeData[];
}

export interface ISubFormativeEntity {
  _totalAssignedLos: number;
  _totalCompletedLos: number;
  _avgScore: number;
}

export interface IClassDataEntity extends ISubFormativeEntity {
  _classId: string;
  _className: string;
  _gradeCode: string;
  _gradeTitle: string;
}

export interface IClassesDataEntity extends IDomainFormativeDataEntity {
  _classes: IClassDataEntity[];
}

export interface IFormativeTeacherResponse extends IResponse {
  _entity: {
    _generationTime: string;
    _domainResponse: IClassesDataEntity[];
  };
}
export interface IFormativeGradeResponse extends IFormativeTeacherResponse {}

export interface IClassFormativeData {
  totalCompleted: number;
  avgScore: number;
  classCode: string;
  gradeCode: string;
  gradeTitle: string;
  totalAssigned: number;
  classTitle: string;
}
export interface ITeacherDomainFormativeData extends IDomainFormativeData {
  classes: IClassFormativeData[];
}

export interface IGradeDataEntity extends IDataEntity {
  _gradeCode: string;
  _gradeTitle: string;
}

export interface IGradesDataEntity extends IDomainFormativeDataEntity {
  _grades: IGradeDataEntity[];
}

export interface IFormativeGradesResponse extends IResponse {
  _entity: {
    _generationTime: string;
    _domainResponse: IGradesDataEntity[];
  };
}

export interface IGradeFormativeData extends IFormativeEntity {
  gradeCode: string;
  gradeTitle: string;
}
export interface IGradesDomainFormativeData extends IDomainFormativeData {
  grades: IGradeFormativeData[];
}

export interface IStudentDataEntity extends ISubFormativeEntity {
  _studentId: number;
  _studentName: string;
}

export interface IStudentsDataEntity extends IDomainFormativeDataEntity {
  _students: IStudentDataEntity[];
}

export interface IFormativeClassResponse extends IResponse {
  _entity: {
    _generationTime: string;
    _domainResponse: IStudentsDataEntity[];
  };
}

export interface IStudentFormativeData extends IFormativeEntity {
  studentCode: number;
  studentFirstName: string;
  studentLastName: string;
}
export interface IStudentsDomainFormativeData extends IDomainFormativeData {
  students: IStudentFormativeData[];
}

interface IFormativeTeacherRequest {
  period: PeriodValue;
  teacher: string;
}
interface IFormativeGradeRequest {
  period: PeriodValue;
  grade: string;
}

interface IFormativeClassRequest {
  period: PeriodValue;
  classId: string;
}

interface ITeachersUsageResponse extends IResponse {
  _entity: {
    _totalTeachers: number;
    _teachersWithAssignment: number;
    _activeTeachers: number;
  };
}

interface ITeachersUsageRequest {
  startDate: string;
  endDate: string;
}

interface IStudentsUsageResponse extends IResponse {
  _entity: {
    _grades: {
      _gradeId: number;
      _gradeCode: string;
      _totalStudents: number;
      _studentsWithSomeCompletion: number;
      _activeStudents: number;
    }[];
  };
}

interface IStudentsUsageRequest {
  startDate: string;
  endDate: string;
}

const reportsServices = API.injectEndpoints({
  endpoints(build) {
    return {
      fetchProgressTeachers: build.query<
        IProgressTeachersResponse,
        PeriodValue
      >({
        query(period) {
          return `/hod/teacher/progress?period=${period}`;
        },
      }),

      fetchProgressTeacher: build.query<
        IProgressTeacherResponse,
        IProgressTeacherRequest
      >({
        query({ period, teacher }) {
          return `/hod/teacher/progress/${teacher}?period=${period}`;
        },
      }),

      fetchProgressGrades: build.query<IProgressGradesResponse, PeriodValue>({
        query(period) {
          return `/hod/grades/progress?period=${period}`;
        },
      }),

      fetchProgressGrade: build.query<
        IProgressGradeResponse,
        IProgressGradeRequest
      >({
        query({ grade, period }) {
          return `/hod/grades/progress/${grade}?period=${period}`;
        },
      }),

      fetchProgressClass: build.query<
        IProgressClassResponse,
        IProgressClassRequest
      >({
        query({ classId, period }) {
          return `/hod/teacher/progress/class/${classId}?period=${period}`;
        },
      }),
      fetchLessonsNFreeplay: build.query<ILessonsNFreePlayResponse, void>({
        query() {
          return `/hod/lessons-free-play-report`;
        },
      }),
      fetchTotalQuestions: build.query<ITotalQuestionsResponse, void>({
        query() {
          return `/hod/total-number-of-questions`;
        },
      }),
      fetchGRStatistics: build.query<IGRStatisticsResponse, void>({
        query() {
          return `/hod/guided-reading-breakdown`;
        },
      }),

      fetchFormativeTeachers: build.query<
        IFormativeTeachersResponse,
        PeriodValue
      >({
        query(period) {
          return `/hod/teacher/formative?period=${period}`;
        },
      }),

      fetchFormativeTeacher: build.query<
        IFormativeTeacherResponse,
        IFormativeTeacherRequest
      >({
        query({ period, teacher }) {
          return `/hod/teacher/formative/${teacher}?period=${period}`;
        },
      }),

      fetchFormativeGrades: build.query<IFormativeGradesResponse, PeriodValue>({
        query(period) {
          return `/hod/grades/formative?period=${period}`;
        },
      }),

      fetchFormativeGrade: build.query<
        IFormativeGradeResponse,
        IFormativeGradeRequest
      >({
        query({ grade, period }) {
          return `/hod/grades/formative/${grade}?period=${period}`;
        },
      }),

      fetchFormativeClass: build.query<
        IFormativeClassResponse,
        IFormativeClassRequest
      >({
        query({ classId, period }) {
          return `/hod/teacher/formative/class/${classId}?period=${period}`;
        },
      }),

      fetchTeachersUsage: build.query<
        ITeachersUsageResponse,
        ITeachersUsageRequest
      >({
        query({ startDate, endDate }) {
          return `/hod/teacher-status-report?start_date=${startDate}&end_date=${endDate}`;
        },
      }),

      fetchStudentsUsage: build.query<
        IStudentsUsageResponse,
        IStudentsUsageRequest
      >({
        query({ startDate, endDate }) {
          return `/hod/student-status-report?start_date=${startDate}&end_date=${endDate}`;
        },
      }),
    };
  },
});

export const {
  useFetchProgressTeachersQuery,
  useFetchProgressTeacherQuery,
  useFetchProgressGradesQuery,
  useFetchProgressGradeQuery,
  useFetchProgressClassQuery,
  useFetchLessonsNFreeplayQuery,
  useFetchTotalQuestionsQuery,
  useFetchGRStatisticsQuery,
  useFetchFormativeTeachersQuery,
  useFetchFormativeTeacherQuery,
  useFetchFormativeGradesQuery,
  useFetchFormativeGradeQuery,
  useFetchFormativeClassQuery,
  useFetchTeachersUsageQuery,
  useFetchStudentsUsageQuery,
} = reportsServices;
